/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_page_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `What are OERs?`
};

const fr_oer_information_page_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Que sont les REL ?`
};

const de_oer_information_page_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Was sind OER?`
};

const es_oer_information_page_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `¿Qué son los REA?`
};

const it_oer_information_page_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `Cosa sono le OER?`
};

const ar_oer_information_page_title23 = /** @type {(inputs: {}) => string} */ () => {
	return `ما هي الموارد التعليمية المفتوحة؟`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_page_title23 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_page_title23(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_page_title23", locale)
	if (locale === "en") return en_oer_information_page_title23(inputs)
	if (locale === "fr") return fr_oer_information_page_title23(inputs)
	if (locale === "de") return de_oer_information_page_title23(inputs)
	if (locale === "es") return es_oer_information_page_title23(inputs)
	if (locale === "it") return it_oer_information_page_title23(inputs)
	return ar_oer_information_page_title23(inputs)
};
export { oer_information_page_title23 as "OER_INFORMATION_PAGE_TITLE" }